import React, { ErrorInfo, ReactNode } from 'react'
import { logger } from 'utils/logger'
import { ErrorPageLayout } from './ErrorPageLayout'

type State = {
  hasError: boolean
  error: unknown
}

type Props = {
  children: ReactNode
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: undefined }
  }

  static getDerivedStateFromError(error: unknown) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger('fatal', new Error('Error boundary caught an error', { cause: error }), {
      context: {
        props: this.props,
        stack: info.componentStack,
      },
    })
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // Use the dedicated error page for React errors
      return (
        <ErrorPageLayout
          title={'An error occurred'}
          message={'Something unexpected happened. Please try again later.'}
        />
      )
    }

    // Return children components in case of no error
    return <>{this.props.children}</>
  }
}
